<template>
    <div>
		<top-header></top-header>
		<main-nav></main-nav>
	    <div class="main-content">
	        <div class="container">
	            <div class="row">
	                <div class="col-md-10 offset-1 my-5">
	                	<router-view/>
	                </div>
	             </div>
	        </div>
	    </div>
	</div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import MainNav from '@/components/SideNav.vue'

  export default{
  	name: "App",
  	components: {
  		'top-header' : Header,
  		'main-nav': MainNav,
  	}
  }
</script>


// WEBPACK FOOTER //
// src/App.vue